import { Component, OnInit } from '@angular/core';
import { faTrash,faPlusCircle,faEdit, faDownload } from '@fortawesome/free-solid-svg-icons';
import { ProfileService } from "src/app/services/profile.service";
import { MainpageService } from "src/app/services/mainpage.service";
import { SelectdropdownService } from "src/app/services/selectdropdown.service";
import { PortalUserDto } from 'src/app/models/portalUserDto';
import { EditUserPortal } from 'src/app/models/editUserPortal';
import { DatePipe } from '@angular/common';
import { SelectdropdownResultResults } from 'src/app/models/selectdropdown';
import { EditUserRelativesDto } from 'src/app/models/editUserRelatives';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { FamilymembersmodalComponent } from 'src/app/components/familymembersmodal/familymembersmodal.component';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { PortalUserAttachmentsDto } from 'src/app/models/PortalUserAttachmentsDto';
import { AttachmentsmodalComponent } from '../attachmentsmodal/attachmentsmodal.component';
import { PortalRequestAttachmentCreate, PortalUserAttachmentsCreate, portalRequestCreate } from 'src/app/models/portalRequestCreate';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  providers: [ DatePipe ]
})
export class ProfileComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private datePipe: DatePipe,
    private ProfileService:ProfileService,
    private dropdownsService:SelectdropdownService,
    private toastr: ToastrService,
    private MainpageService:MainpageService,
    private matDialog:MatDialog,
    public translate: TranslateService,
   

  ) { }
  
  // Icons
  deleteIcon=faTrash;
  addIcon=faPlusCircle;
  editIcon=faEdit;
  downloadIcon=faDownload;
  // ======
  userData = new PortalUserDto(); 
  name:string;
  nameEn:string;
  employer:string;
  notes:string;
  idNumber:string;
  citiesList:any=[];
  genderList:any=[];
  nationalityList:any=[];
  qualificationsList:any=[];
  relativesTypeList:any=[];
  educationalStageList:any=[];
  maritalStatusList:any=[];
  caseCategoryList:any=[];
  wifeNationality1List:any=[];
  wifeNationality2List:any=[];
  wifeNationality3List:any=[];
  wifeNationality4List:any=[];
  WifeHelthStatus1List:any=[];
  WifeHelthStatus2List:any=[];
  WifeHelthStatus3List:any=[];
  WifeHelthStatus4List:any=[];
  wifeQualification1List:any=[];
  wifeQualification2List:any=[];
  wifeQualification3List:any=[];
  wifeQualification4List:any=[];
  bankList:any=[];
  branchList:any=[];
  attachmentName:string;
  filePath:string;
  fileExt:string;
  requestAttachments:PortalRequestAttachmentCreate[];
  requestAttachments2:PortalUserAttachmentsCreate[];
  addRequest = new portalRequestCreate();

 
  RelativeEditObj:EditUserRelativesDto;
  RelativeEditObjIndex=null;
  loadingOverlay = true;
  disabled=false;

  AttachmentEditObj:PortalUserAttachmentsDto;
  AttachmentEditObjIndex=null;


  // Errors
  idExpirationDateError=false;
  birthDateError=false;
  genderLkpIdError=false;
  nationalityLkpIdError=false;
  mobileNumber1Error=false;
  educationalStageLkpError=false;
  maritalStatusLkpIdError=false;
  cityLkpIdError=false;
  caseCategoryLkpIdError=false;
  regionError=false;
  idNumberError=false;
  idNumberWifeHusband1Error=false;
  idNumberWife2Error=false;
  idNumberWife3Error=false;
  idNumberWife4Error=false;
  aidRequestTypeError=false;

  toastrMsgs:any;
  profileSubmitted = false;
  attachmentArray:PortalUserAttachmentsDto[];

  ngOnInit() {
    debugger
    this.getToastrMsgs();
    this.MainpageService.GetDashboardDataTable()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.loadingOverlay = false;
      if(data.result.totalCount > 0){
        this.disabled=true;
      }
    })
    debugger
    this.ProfileService.GetProfileData()
    
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      console.log(data);
      this.userData =  data.result;
      console.log(this.userData);
      
      this.userData.birthDate = this.fromStringToDate(data.result.birthDate);
      this.userData.idExpirationDate = this.fromStringToDate(data.result.idExpirationDate);
      if(data.result.passportExpiryDate){this.userData.passportExpiryDate = this.fromStringToDate(data.result.passportExpiryDate);}
      if(data.result.passportIssueDate){this.userData.passportIssueDate = this.fromStringToDate(data.result.passportIssueDate);}
      if(data.result.residenceEndDate){this.userData.residenceEndDate = this.fromStringToDate(data.result.residenceEndDate);}
      if(data.result.wifeIdExpirationDate){this.userData.wifeIdExpirationDate = this.fromStringToDate(data.result.wifeIdExpirationDate);}
      if(data.result.wifeIdExpirationDate2){this.userData.wifeIdExpirationDate2 = this.fromStringToDate(data.result.wifeIdExpirationDate2);}
      if(data.result.wifeIdExpirationDate3){this.userData.wifeIdExpirationDate3 = this.fromStringToDate(data.result.wifeIdExpirationDate3);}
      if(data.result.wifeIdExpirationDate4){this.userData.wifeIdExpirationDate4 = this.fromStringToDate(data.result.wifeIdExpirationDate4);}
      this.loadingOverlay = false;
    });
   
    this.initRelativeEditObj();  
    this.initAttachmentEditObj();
    // Cities Select Drop Down
    this.dropdownsService.GetCitiesList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.citiesList = data;
    })
    // CaseCategory Select Drop Down
    this.dropdownsService.GetCaseCategoryList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.caseCategoryList = data;
    })

    // Gender Select Drop Down
    this.dropdownsService.GetGenderList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.genderList = data;
    })

    // Nationality Select Drop Down
    this.dropdownsService.GetNationalityList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.nationalityList = data;
    })

    // Qualifications Select Drop Down
    this.dropdownsService.GetQualificationsList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.qualificationsList = data;
    })

    // RelativesType Select Drop Down
    this.dropdownsService.GetRelativesTypeList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.relativesTypeList = data;
    })
    // EducationalStage Select Drop Down
    this.dropdownsService.GetEducationalStageList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.educationalStageList = data;
    })
    // MaritalStatus Select Drop Down
    this.dropdownsService.GetMaritalStatusList()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.maritalStatusList = data;
    })
    // WifeNationality1Lkp Select Drop Down
    this.dropdownsService.GetWifeNationality1()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.wifeNationality1List = data;
    })
    // WifeNationality2Lkp Select Drop Down
    this.dropdownsService.GetWifeNationality2()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.wifeNationality2List = data;
    })
    // WifeNationality3Lkp Select Drop Down
    this.dropdownsService.GetWifeNationality3()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.wifeNationality3List = data;
    })
    // WifeNationality4Lkp Select Drop Down
    this.dropdownsService.GetWifeNationality4()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.wifeNationality4List = data;
    })
    // wifeHelthStatusLkp1 Select Drop Down
    this.dropdownsService.GetWifeHelthStatus1()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.WifeHelthStatus1List = data;
    })
    // wifeHelthStatusLkp2 Select Drop Down
    this.dropdownsService.GetWifeHelthStatus2()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.WifeHelthStatus2List = data;
    })
     // wifeHelthStatusLkp3 Select Drop Down
     this.dropdownsService.GetWifeHelthStatus3()
     .pipe(takeUntil(this.destroy$))
     .subscribe(data=>{
       this.WifeHelthStatus3List = data;
     })
      // wifeHelthStatusLkp4 Select Drop Down
    this.dropdownsService.GetWifeHelthStatus4()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.WifeHelthStatus4List = data;
    })
    // WifeQualification1 Select Drop Down
    this.dropdownsService.GetWifeQualification1()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.wifeQualification1List = data;
    })
     // WifeQualification2 Select Drop Down
     this.dropdownsService.GetWifeQualification2()
     .pipe(takeUntil(this.destroy$))
     .subscribe(data=>{
       this.wifeQualification2List = data;
     })
      // WifeQualification3 Select Drop Down
    this.dropdownsService.GetWifeQualification3()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      this.wifeQualification3List = data;
    })
     // WifeQualification4 Select Drop Down
     this.dropdownsService.GetWifeQualification4()
     .pipe(takeUntil(this.destroy$))
     .subscribe(data=>{
       this.wifeQualification4List = data;
     })
     // bank Select Drop Down
     this.dropdownsService.GetBank()
     .pipe(takeUntil(this.destroy$))
     .subscribe(data=>{
       this.bankList = data;
     })
     // branch Select Drop Down
     this.dropdownsService.Getbranch()
     .pipe(takeUntil(this.destroy$))
     .subscribe(data=>{
       this.branchList = data;
     })

     


  }

  ngOnDestroy() {
    this.destroy$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.destroy$.unsubscribe();
  }

  fromStringToDate(str):any{
    let parts = str.split("/");
    return new Date(parts[2], parts[1] - 1, parts[0])
  }

  initRelativeEditObj(){
    this.RelativeEditObj= new EditUserRelativesDto();
    this.RelativeEditObj.name=null;
    this.RelativeEditObj.idNumber=null;
    this.RelativeEditObj.genderLkpId = null;
    this.RelativeEditObj.relativesTypeLkpId = null;
    this.RelativeEditObj.nationalityLkpId = null;
    this.RelativeEditObj.qualificationLkpId = null;
    this.RelativeEditObj.educationalStageLkpId = null;
    this.RelativeEditObj.maritalStatusLkpId = null;
    this.RelativeEditObjIndex = null;
  }
  initAttachmentEditObj(){
    this.AttachmentEditObj= new PortalUserAttachmentsDto();
    this.AttachmentEditObj.attachmentName=null;
    this.AttachmentEditObj.filePath=null;
    this.AttachmentEditObjIndex = null;
  }
  focused(event){
    if(event.target.previousSibling.classList.contains('label-over')){
      return false;
    }else{
      event.target.previousSibling.classList.add('label-over');
    }
  }

  blured(event,value){
    if(event.target.previousSibling.classList.contains('label-over') && !value){
      event.target.previousSibling.classList.remove('label-over');
    }else{
      return false;
    }
  }

  getTextFromSelect(id:number,list:SelectdropdownResultResults[]){
    let obj =  list.find(x=>x.id == id);
    if (obj) {
      return obj.text
    }
  }

  getToastrMsgs(){
    this.translate.get('ToastrSuccess')
    .pipe(takeUntil(this.destroy$))
    .subscribe(data=>{      
      this.toastrMsgs = data;
    })
  }

  validate(){
    if(!this.userData.idNumber || this.userData.idNumber.length != 18){this.idNumberError=true;}else{this.idNumberError=false;}
    if(this.userData.wifeHusbandName1 && this.userData.idNumberWifeHusband1.length != 18){this.idNumberWifeHusband1Error=true;}else{this.idNumberWifeHusband1Error=false;}
    if(this.userData.wifeName2 && this.userData.idNumberWife2.length != 18){this.idNumberWife2Error=true;}else{this.idNumberWife2Error=false;}
    if(this.userData.wifeName3 && this.userData.idNumberWife3.length != 18){this.idNumberWife3Error=true;}else{this.idNumberWife3Error=false;}
    if(this.userData.wifeName4 && this.userData.idNumberWife4.length != 18){this.idNumberWife4Error=true;}else{this.idNumberWife4Error=false;}
    if(!this.userData.idExpirationDate){this.idExpirationDateError=true;}else{this.idExpirationDateError=false;}
    if(!this.userData.birthDate){this.birthDateError=true;}else{this.birthDateError=false;}
    if(!this.userData.genderLkpId){this.genderLkpIdError=true;}else{this.genderLkpIdError=false;}
    if(!this.userData.nationalityLkpId){this.nationalityLkpIdError=true;}else{this.nationalityLkpIdError=false;}
    if(!this.userData.cityLkpId){this.cityLkpIdError=true;}else{this.cityLkpIdError=false;}
    if(!this.userData.caseCategoryLkpId){this.caseCategoryLkpIdError=true;}else{this.caseCategoryLkpIdError=false;}
    if(!this.userData.region){this.regionError=true;}else{this.regionError=false;}
    if(!this.userData.educationalStageLkpId){this.educationalStageLkpError=true;}else{this.educationalStageLkpError=false;}
    if(!this.userData.maritalStatusLkpId){this.maritalStatusLkpIdError=true;}else{this.maritalStatusLkpIdError=false;}
    if(!this.userData.mobileNumber1){this.mobileNumber1Error=true;}else{this.mobileNumber1Error=false;}
    
    if (
      this.idNumberError==true || this.idExpirationDateError==true || this.birthDateError==true ||
      this.genderLkpIdError==true || this.nationalityLkpIdError==true || this.cityLkpIdError==true ||this.caseCategoryLkpIdError==true ||
      this.regionError==true || this.maritalStatusLkpIdError==true || this.mobileNumber1Error==true ||
      this.idNumberWifeHusband1Error==true || this.idNumberWife2Error==true || this.idNumberWife3Error==true || 
      this.idNumberWife4Error==true
      ) {
      return false;
    }else{
      return true
    }
    
  }

  validateIdNumberLength(val){
    val.length == 18? true : false;
  }

  getPic(fileExt:string){
    if(fileExt){
      if(fileExt.toLowerCase().includes("png") || fileExt.toLowerCase().includes("jpg") || fileExt.toLowerCase().includes("jpeg")){
        return 1
      }else{
        return 2
      }
    }
  }
  
  addRelative(){
    let matDialog = new MatDialogConfig();
    matDialog.disableClose = true;
    matDialog.data = {
      RelativeEditObjIndex: this.RelativeEditObjIndex,
      RelativeEditObj: this.RelativeEditObj, 
      name:this.name,
      employer:this.employer,
      notes:this.notes,
      idNumber:this.idNumber,
      genderList:this.genderList, 
      nationalityList:this.nationalityList, 
      relativesTypeList:this.relativesTypeList,
      qualificationsList:this.qualificationsList,
      educationalStageList:this.educationalStageList,
      maritalStatusList:this.maritalStatusList}
      
    this.matDialog.open(FamilymembersmodalComponent,matDialog)
    .afterClosed().subscribe(res=>{
      if(res == null || res == undefined){
        this.initRelativeEditObj();
        return false
      }else{
        console.log(res);
        
        let newRleative = new EditUserRelativesDto();
        newRleative.rowStatus = 'New';
        newRleative.name = this.RelativeEditObj.name;
        newRleative.employer = this.RelativeEditObj.employer;
        newRleative.notes = this.RelativeEditObj.notes;
        newRleative.idNumber = this.RelativeEditObj.idNumber;
        newRleative.genderLkpId = this.RelativeEditObj.genderLkpId;
        newRleative.relativesTypeLkpId = this.RelativeEditObj.relativesTypeLkpId;
        newRleative.nationalityLkpId = this.RelativeEditObj.nationalityLkpId;
        newRleative.qualificationLkpId = this.RelativeEditObj.qualificationLkpId;
        newRleative.educationalStageLkpId = this.RelativeEditObj.educationalStageLkpId;
        newRleative.maritalStatusLkpId = this.RelativeEditObj.maritalStatusLkpId;
        newRleative.genderLkp = this.getTextFromSelect(this.RelativeEditObj.genderLkpId,this.genderList)
        newRleative.relativesTypeLkp = this.getTextFromSelect(this.RelativeEditObj.relativesTypeLkpId,this.relativesTypeList);
        newRleative.nationalityLkp = this.getTextFromSelect(this.RelativeEditObj.nationalityLkpId,this.nationalityList);
        newRleative.qualificationLkp = this.getTextFromSelect(this.RelativeEditObj.qualificationLkpId,this.qualificationsList);
        newRleative.educationalStageLkp = this.getTextFromSelect(this.RelativeEditObj.educationalStageLkpId,this.educationalStageList);
        newRleative.maritalStatusLkp = this.getTextFromSelect(this.RelativeEditObj.maritalStatusLkpId,this.maritalStatusList);
        this.userData.userRelatives.push(newRleative);
        this.initRelativeEditObj();
      }
    });
  }
  
  addAttachment(){
    let matDialog = new MatDialogConfig();
    matDialog.disableClose = true;
    matDialog.data = {
      AttachmentEditObjIndex: this.AttachmentEditObjIndex,
      AttachmentEditObj: this.AttachmentEditObj, 
      attachmentName:this.attachmentName,
      filePath:this.filePath}
      
      
    this.matDialog.open(AttachmentsmodalComponent,matDialog)
    .afterClosed().subscribe(res=>{
      if(res == null || res == undefined){
        this.initAttachmentEditObj();
        return false
      }else{
        console.log(res);
        
        let newAttachment = new PortalUserAttachmentsDto();
        newAttachment.rowStatus = 'New';
        newAttachment.attachmentName = this.AttachmentEditObj.attachmentName;
        newAttachment.filePath=this.AttachmentEditObj.filePath;
        this.userData.userAttachments.push(newAttachment);
        console.log(this.userData.userAttachments);
        this.initAttachmentEditObj();
      }
    });
  }

  editRelative(i){
    this.RelativeEditObj.id = this.userData.userRelatives[i].id;
    this.RelativeEditObj.name = this.userData.userRelatives[i].name;
    this.RelativeEditObj.employer = this.userData.userRelatives[i].employer;
    this.RelativeEditObj.notes = this.userData.userRelatives[i].notes;
    this.RelativeEditObj.idNumber = this.userData.userRelatives[i].idNumber;
    this.RelativeEditObj.genderLkpId = this.userData.userRelatives[i].genderLkpId;
    this.RelativeEditObj.relativesTypeLkpId = this.userData.userRelatives[i].relativesTypeLkpId;
    this.RelativeEditObj.nationalityLkpId = this.userData.userRelatives[i].nationalityLkpId;
    this.RelativeEditObj.qualificationLkpId = this.userData.userRelatives[i].qualificationLkpId;
    this.RelativeEditObj.educationalStageLkpId = this.userData.userRelatives[i].educationalStageLkpId;
    this.RelativeEditObj.maritalStatusLkpId = this.userData.userRelatives[i].maritalStatusLkpId;
    this.RelativeEditObjIndex = i;
    let matDialog = new MatDialogConfig();
    matDialog.disableClose = true;
    matDialog.data = {
      RelativeEditObjIndex: this.RelativeEditObjIndex, 
      RelativeEditObj: this.RelativeEditObj, 
      genderList:this.genderList, 
      nationalityList:this.nationalityList, 
      relativesTypeList:this.relativesTypeList, 
      qualificationsList:this.qualificationsList,
      educationalStageList:this.educationalStageList,
      maritalStatusList:this.maritalStatusList}
    this.matDialog.open(FamilymembersmodalComponent,matDialog)
    .afterClosed().subscribe(res=>{
      if(res == null || res == undefined){
        this.initRelativeEditObj();
        return false
      }else{
        console.log(res);
        let newRleative = new EditUserRelativesDto();
        newRleative.name = this.RelativeEditObj.name;
        newRleative.employer = this.RelativeEditObj.employer;
        newRleative.notes = this.RelativeEditObj.notes;
        newRleative.idNumber = this.RelativeEditObj.idNumber;
        newRleative.genderLkpId = this.RelativeEditObj.genderLkpId;
        newRleative.relativesTypeLkpId = this.RelativeEditObj.relativesTypeLkpId;
        newRleative.nationalityLkpId = this.RelativeEditObj.nationalityLkpId;
        newRleative.qualificationLkpId = this.RelativeEditObj.qualificationLkpId;
        newRleative.educationalStageLkpId = this.RelativeEditObj.educationalStageLkpId;
        newRleative.maritalStatusLkpId = this.RelativeEditObj.maritalStatusLkpId;
        newRleative.genderLkp = this.getTextFromSelect(this.RelativeEditObj.genderLkpId,this.genderList)
        newRleative.relativesTypeLkp = this.getTextFromSelect(this.RelativeEditObj.relativesTypeLkpId,this.relativesTypeList);
        newRleative.nationalityLkp = this.getTextFromSelect(this.RelativeEditObj.nationalityLkpId,this.nationalityList);
        newRleative.qualificationLkp = this.getTextFromSelect(this.RelativeEditObj.qualificationLkpId,this.qualificationsList);
        newRleative.educationalStageLkp = this.getTextFromSelect(this.RelativeEditObj.educationalStageLkpId,this.educationalStageList);
        newRleative.maritalStatusLkp = this.getTextFromSelect(this.RelativeEditObj.maritalStatusLkpId,this.maritalStatusList);
        if(!newRleative.id){
          newRleative.rowStatus = 'Updated';
          let relative = this.userData.userRelatives[this.RelativeEditObjIndex];
          relative.name = newRleative.name;
          relative.employer = newRleative.employer;
          relative.notes = newRleative.notes;
          relative.idNumber = newRleative.idNumber;
          relative.genderLkpId = newRleative.genderLkpId;
          relative.relativesTypeLkpId = newRleative.relativesTypeLkpId;
          relative.nationalityLkpId = newRleative.nationalityLkpId;
          relative.qualificationLkpId = newRleative.qualificationLkpId;
          relative.educationalStageLkpId = newRleative.educationalStageLkpId;
          relative.maritalStatusLkpId = newRleative.maritalStatusLkpId;
          relative.genderLkp = this.getTextFromSelect(newRleative.genderLkpId,this.genderList)
          relative.relativesTypeLkp = this.getTextFromSelect(newRleative.relativesTypeLkpId,this.relativesTypeList);
          relative.nationalityLkp = this.getTextFromSelect(newRleative.nationalityLkpId,this.nationalityList);
          relative.qualificationLkp = this.getTextFromSelect(newRleative.qualificationLkpId,this.qualificationsList);
          relative.educationalStageLkp = this.getTextFromSelect(newRleative.educationalStageLkpId,this.educationalStageList);
          relative.maritalStatusLkp = this.getTextFromSelect(newRleative.maritalStatusLkpId,this.maritalStatusList);
          relative.rowStatus = newRleative.rowStatus;
        }else{
          let relative = this.userData.userRelatives[this.RelativeEditObjIndex];
          relative.name = newRleative.name;
          relative.employer = newRleative.employer;
          relative.notes = newRleative.notes;
          relative.idNumber = newRleative.idNumber;
          relative.genderLkpId = newRleative.genderLkpId;
          relative.relativesTypeLkpId = newRleative.relativesTypeLkpId;
          relative.nationalityLkpId = newRleative.nationalityLkpId;
          relative.qualificationLkpId = newRleative.qualificationLkpId;
          relative.educationalStageLkpId = newRleative.educationalStageLkpId;
          relative.maritalStatusLkpId = newRleative.maritalStatusLkpId;
          relative.genderLkp = this.getTextFromSelect(newRleative.genderLkpId,this.genderList)
          relative.relativesTypeLkp = this.getTextFromSelect(newRleative.relativesTypeLkpId,this.relativesTypeList);
          relative.nationalityLkp = this.getTextFromSelect(newRleative.nationalityLkpId,this.nationalityList);
          relative.qualificationLkp = this.getTextFromSelect(newRleative.qualificationLkpId,this.qualificationsList);
          relative.educationalStageLkp = this.getTextFromSelect(newRleative.educationalStageLkpId,this.educationalStageList);
          relative.maritalStatusLkp = this.getTextFromSelect(newRleative.maritalStatusLkpId,this.maritalStatusList);
        }
        this.initRelativeEditObj();
      }
    });
  }

  editAttachment(i){
    this.AttachmentEditObj.id = this.userData.userAttachments[i].id;
    this.AttachmentEditObj.attachmentName = this.userData.userAttachments[i].attachmentName;
    this.AttachmentEditObj.filePath = this.userData.userAttachments[i].filePath;
    
    this.AttachmentEditObjIndex = i;
    let matDialog = new MatDialogConfig();
    matDialog.disableClose = true;
    matDialog.data = {
      AttachmentEditObjIndex: this.AttachmentEditObjIndex, 
      AttachmentEditObj: this.AttachmentEditObj, 
     }
    this.matDialog.open(AttachmentsmodalComponent,matDialog)
    .afterClosed().subscribe(res=>{
      if(res == null || res == undefined){
        this.initAttachmentEditObj();
        return false
      }else{
        console.log(res);
        let newAttachment = new PortalUserAttachmentsDto();
        newAttachment.attachmentName = this.AttachmentEditObj.attachmentName;
        newAttachment.filePath = this.AttachmentEditObj.filePath;
        
        if(!newAttachment.id){
          newAttachment.rowStatus = 'Updated';
          let attachment = this.userData.userAttachments[this.AttachmentEditObjIndex];
          attachment.attachmentName = newAttachment.attachmentName;
          attachment.filePath = newAttachment.filePath;
         
          attachment.rowStatus = newAttachment.rowStatus;
        }else{
          let attachment = this.userData.userAttachments[this.AttachmentEditObjIndex];
          attachment.attachmentName = newAttachment.attachmentName;
          attachment.filePath = newAttachment.filePath;
        }
        this.initAttachmentEditObj();
      }
    });
  }

  deleteRelative(i){
    let relative = this.userData.userRelatives[i];
    if (relative.id) {
      relative.rowStatus = 'Deleted';
    }else{
      this.userData.userRelatives.splice(i, 1);
    }
  }

  deleteAttachment(i){
    let attachment = this.userData.userAttachments[i];
    if (attachment.id) {
      attachment.rowStatus = 'Deleted';
    }else{
      this.userData.userAttachments.splice(i, 1);
    }
  }


  sumbitForm(){
    
    if(this.validate()){
      this.loadingOverlay = true;
      let updateData = new EditUserPortal();
      
      updateData.name = this.userData.name;

      updateData.employer = this.userData.employer;
      updateData.notes = this.userData.notes;
      updateData.birthDate = this.datePipe.transform(this.userData.birthDate,"dd/MM/yyyy")
      updateData.birthDateStr = this.userData.birthDateStr;
      updateData.cityLkpId = this.userData.cityLkpId;
      updateData.genderLkpId = this.userData.genderLkpId;
      updateData.caseCategoryLkpId=this.userData.caseCategoryLkpId;
      updateData.nationalityLkpId = this.userData.nationalityLkpId;
      updateData.qualificationLkpId = this.userData.qualificationLkpId;
      updateData.educationalStageLkpId=this.userData.educationalStageLkpId;
      updateData.maritalStatusLkpId = this.userData.maritalStatusLkpId;
      updateData.region = this.userData.region;
      updateData.idNumber = this.userData.idNumber;
      updateData.idExpirationDate = this.datePipe.transform(this.userData.idExpirationDate,"dd/MM/yyyy")
      updateData.idExpirationDateStr = this.userData.idExpirationDateStr;
      updateData.wifeHusbandName1 = this.userData.wifeHusbandName1;
      updateData.idNumberWifeHusband1 = this.userData.idNumberWifeHusband1;
      updateData.wifeName2 = this.userData.wifeName2;
      updateData.wifeName3 = this.userData.wifeName3;
      updateData.wifeName4 = this.userData.wifeName4;
      updateData.jobWifeHusband1 = this.userData.jobWifeHusband1;
      updateData.wifeNationalityLkpId=this.userData.wifeNationalityLkpId;
      (this.userData.wifeIdExpirationDate) ? updateData.wifeIdExpirationDate = this.datePipe.transform(this.userData.wifeIdExpirationDate,"dd/MM/yyyy") : updateData.wifeIdExpirationDate =  this.userData.wifeIdExpirationDate;
      updateData.wifeHelthStatusLkpId=this.userData.wifeHelthStatusLkpId;
      updateData.wifeQualificationLkpId=this.userData.wifeQualificationLkpId;
      updateData.jobWife2 = this.userData.jobWife2;
      updateData.wifeNationality2LkpId=this.userData.wifeNationality2LkpId;
      (this.userData.wifeIdExpirationDate2) ? updateData.wifeIdExpirationDate2 = this.datePipe.transform(this.userData.wifeIdExpirationDate2,"dd/MM/yyyy") : updateData.wifeIdExpirationDate2 =  this.userData.wifeIdExpirationDate2;
      updateData.wifeHelthStatus2LkpId=this.userData.wifeHelthStatus2LkpId;
      updateData.wifeQualification2LkpId=this.userData.wifeQualification2LkpId;
      updateData.jobWife3 = this.userData.jobWife3;
      updateData.wifeNationality3LkpId=this.userData.wifeNationality3LkpId;
      (this.userData.wifeIdExpirationDate3) ? updateData.wifeIdExpirationDate3 = this.datePipe.transform(this.userData.wifeIdExpirationDate3,"dd/MM/yyyy") : updateData.wifeIdExpirationDate3 =  this.userData.wifeIdExpirationDate3;
      updateData.wifeHelthStatus3LkpId=this.userData.wifeHelthStatus3LkpId;
      updateData.wifeQualification3LkpId=this.userData.wifeQualification3LkpId;
      updateData.jobWife4 = this.userData.jobWife4;
      updateData.wifeNationality4LkpId=this.userData.wifeNationality4LkpId;
      (this.userData.wifeIdExpirationDate4) ? updateData.wifeIdExpirationDate4 = this.datePipe.transform(this.userData.wifeIdExpirationDate4,"dd/MM/yyyy") : updateData.wifeIdExpirationDate4 =  this.userData.wifeIdExpirationDate4;
      updateData.wifeHelthStatus4LkpId=this.userData.wifeHelthStatus4LkpId;
      updateData.wifeQualification4LkpId=this.userData.wifeQualification4LkpId;
      updateData.branchLkpId=this.userData.branchLkpId;
      updateData.passportNumber = this.userData.passportNumber;
      updateData.unifiedNumber = this.userData.unifiedNumber;
      updateData.electricityMeterNumber = this.userData.electricityMeterNumber;
      updateData.houseNumber = this.userData.houseNumber;
      (this.userData.passportExpiryDate) ? updateData.passportExpiryDate = this.datePipe.transform(this.userData.passportExpiryDate,"dd/MM/yyyy") : updateData.passportExpiryDate =  this.userData.passportExpiryDate;
      (this.userData.passportIssueDate) ? updateData.passportIssueDate =  this.datePipe.transform(this.userData.passportIssueDate,"dd/MM/yyyy") : updateData.passportIssueDate =  this.userData.passportIssueDate;
      (this.userData.residenceEndDate) ? updateData.residenceEndDate =  this.datePipe.transform(this.userData.residenceEndDate,"dd/MM/yyyy") : updateData.residenceEndDate =  this.userData.residenceEndDate;
      updateData.idNumberWife2 = this.userData.idNumberWife2;
      updateData.idNumberWife3 = this.userData.idNumberWife3;
      updateData.idNumberWife4 = this.userData.idNumberWife4;
      updateData.mobileNumber1 = this.userData.mobileNumber1;
      updateData.mobileNumber2 = this.userData.mobileNumber2;
      updateData.jobDescription = this.userData.jobDescription;
      updateData.job = this.userData.job;
      updateData.sponsorName = this.userData.sponsorName;
      updateData.countryNo = this.userData.countryNo;
      updateData.nameEn = this.userData.nameEn;
      updateData.address = this.userData.address;
      updateData.bankLkpId = this.userData.bankLkpId;
      updateData.accountNumber = this.userData.accountNumber;
      updateData.accountOwner = this.userData.accountOwner;
      updateData.ibanNumber = this.userData.ibanNumber;
      
      updateData.id = this.userData.id;
      updateData.userRelatives=[];
       this.userData.userRelatives.forEach(element => {
         updateData.userRelatives.push(element);
       });
       
       updateData.userAttachments=[];
       this.userData.userAttachments.forEach(element => {
         updateData.userAttachments.push(element);
       });
      console.log(updateData);
      this.ProfileService.UpdateProfileData(updateData)
      .pipe(takeUntil(this.destroy$))
      .subscribe(data=>{
        this.toastr.success(this.toastrMsgs.editProfile);
        this.loadingOverlay = false;
        
      },error=>{
        this.toastr.error(error.error.error.message);
        this.loadingOverlay = false;
      })

    }
  }

  
}
